module.exports = __webpack_public_path__ + "img/Compact-FR_Overview-Rear_2.e2cf0072.jpg";